module.exports = __webpack_public_path__ + "img/chr_ts_90_20.60a49c29.png";